import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { SystemIconComponentModule } from '../../atoms/icon/icon.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-system-paginator',
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss',
})
export class PaginatorComponent {
  @Input() currentPage = 0;
  @Input() itemsPerPage = 10;
  @Input() totalItems = 0;
  @Output() pageChanged: EventEmitter<number> = new EventEmitter();

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  get getDisplayedItemsRange(): { start: number; end: number } {
    const start = this.currentPage * this.itemsPerPage + 1;
    const end = Math.min((this.currentPage + 1) * this.itemsPerPage, this.totalItems);

    return {
      start,
      end,
    };
  }

  get pageNumbers(): number[] {
    const totalPages = this.totalPages;
    const currentPage = this.currentPage;
    const maxPagesToShow = 5;

    let startPage: number;
    let endPage: number;

    if (totalPages <= maxPagesToShow) {
      // If total pages are less than or equal to max pages to show, show all pages
      startPage = 1;
      endPage = totalPages;
    } else {
      // Calculate start and end pages
      if (currentPage <= 3) {
        startPage = 1;
        endPage = maxPagesToShow;
      } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - maxPagesToShow + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);
  }

  goToPreviousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.pageChanged.emit(this.currentPage);
    }
  }

  goToNextPage(): void {
    if (this.currentPage <= this.totalPages) {
      this.currentPage++;
      this.pageChanged.emit(this.currentPage);
    }
  }

  goToPage(page: number): void {
    if (page !== null && page !== undefined && page >= 0 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      this.pageChanged.emit(this.currentPage);
    }
  }

  trackByFn(_index: number, page: number) {
    return page;
  }
}

@NgModule({
  declarations: [PaginatorComponent],
  exports: [PaginatorComponent, SystemIconComponentModule],
  imports: [SystemIconComponentModule, CommonModule, TranslateModule],
})
export class SystemPaginatorModule {}
